import { EntityType } from '@frontend/common';
import { OrderClient } from '@frontend/order/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

declare global {
    interface WindowEventMap {
        'useOrder:request': CustomEvent<string>;
    }
}

const REQUEST_EVENT = 'useOrder:request';
const STORAGE_KEY = 'ORDER_REQ';

export function orderRequest(orderId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_EVENT, { detail: orderId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function OrderResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_EVENT, EntityType.ORDER, (ids) => OrderClient.resolveOrders(ids), props.dispatch);
    return <></>;
}
